import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Footer from '../components/footer';
import '../css/pages_styles.css';
import backgroundImage from '../assets/background.png';

const Agenda = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [sidebarExpanded, setSidebarExpanded] = useState(true);

    // 偵測螢幕大小
    useEffect(() => {
        const checkScreenSize = () => {
            const width = window.innerWidth;
            setIsMobile(width <= 768);
        };

        // 初始檢查
        checkScreenSize();

        // 監聽視窗大小變化
        window.addEventListener('resize', checkScreenSize);
        
        // 清理事件監聽器
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    // 監聽 sidebar 狀態變化的函數
    const handleSidebarToggle = (isExpanded) => {
        setSidebarExpanded(isExpanded);
    };

    return (
        <div className="agenda-page">
            <Sidebar onToggle={handleSidebarToggle} />
            <div 
                className={`agenda-main-content ${isMobile ? '' : (sidebarExpanded ? 'agenda-main-content-expanded' : '')}`}
            >
                <div className="agenda-container">
                    <header 
                        className="agenda-header"
                        style={{ backgroundImage: `url(${backgroundImage})` }}
                    >
                        <h1 className="agenda-title">大會議程</h1>
                    </header>
                    
                    <section className="agenda-section">
                        <h1 className="agenda-subtitle">2025/08/25 議程</h1>
                        <div className={`agenda-scroll-hint ${isMobile ? 'agenda-scroll-hint-mobile' : ''}`}>
                            ← 左右滑動查看完整表格 →
                        </div>
                        <div className="agenda-table-container">
                            <table className="agenda-table">
                                <thead>
                                    <tr>
                                        <th className="agenda-th">時間</th>
                                        <th className="agenda-th" colSpan="3">活動</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="agenda-td">09:00-10:00</td>
                                        <td className="agenda-td" colSpan="3">報到</td>
                                    </tr>
                                    <tr>
                                        <td className="agenda-td">10:00-10:50</td>
                                        <td className="agenda-td agenda-poster-blue">
                                            Poster<br />
                                            論文研究成果發表 I <br />
                                            (亞歷山大廳)
                                        </td>
                                        <td className="agenda-td agenda-poster-green" colSpan="2">
                                            Poster<br />
                                            國科會研究成果發表 I<br />
                                            (洛克廳)
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="agenda-td">11:00-11:20</td>
                                        <td className="agenda-td agenda-opening" colSpan="3">
                                            大會開幕<br />
                                            (蘇格拉底廳)
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="agenda-td">11:20-12:10</td>
                                        <td className="agenda-td agenda-keynote" colSpan="3">
                                            Keynote Speech I:<br />
                                            講者:中華電信研究院 蘇添財院長<br />
                                            主題: AI 賦能 ICT：邁向6G智慧應用新篇章<br />
                                            (蘇格拉底廳)
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="agenda-td">12:10-13:20</td>
                                        <td className="agenda-td" colSpan="3">午餐</td>
                                    </tr>
                                    <tr>
                                        <td className="agenda-td">13:20-14:10</td>
                                        <td className="agenda-td agenda-opening" colSpan="3">
                                            Keynote Speech II:<br />
                                            講者:Head AiOT, 59stVentures, Dr. Hwee Pink TAN<br />
                                            主題: AIoT Systems for Ageing-in-Place: Lessons Learnt and Future Opportunities<br />
                                            (蘇格拉底廳)
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="agenda-td">14:10-15:00</td>
                                        <td className="agenda-td agenda-keynote" colSpan="3">
                                            Panel discussion:<br />
                                            主題: 自主智慧重塑跨域與協作生態系統<br /> 
                                            (Autonomous Intelligence Reshaping a Cross-disciplinary and Collaborative Ecosystem)<br />
                                            主持人:<br />
                                            林一平 教授 國立陽明交通大學資訊工程學系 終身講座教授<br />
                                            與談嘉賓:<br />
                                            中央研究院 李育杰研究員<br />
                                            財團法人人工智慧科技基金會 溫怡玲執行長<br />
                                            成功大學敏求智慧運算學院 李韶曼助理教授<br />
                                            廣達電腦 張嘉淵博士技術長<br />
                                            (蘇格拉底廳)
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="agenda-td">15:00-15:20</td>
                                        <td className="agenda-td" colSpan="3">Coffee break</td>
                                    </tr>
                                    <tr>
                                        <td className="agenda-td">15:20-16:10</td>
                                        <td className="agenda-td agenda-poster-green">
                                            學門座談會<br />
                                            主講人：<br />
                                            資訊工程學門召集人 逄愛君教授<br />
                                            資訊工程學門承辦人 羅惠嫻小姐<br />
                                            (蘇格拉底廳)
                                        </td>
                                        <td className="agenda-td agenda-poster-blue">
                                            Poster<br />
                                            論文研成果發表 II<br />
                                            (亞歷山大廳)<br />
                                            <span className="red-text">最佳學生論文評選</span>
                                        </td>
                                        <td className="agenda-td agenda-poster-green">
                                            Poster<br />
                                            國科會研究成果發表 II<br />
                                            (洛克廳)
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="agenda-td">16:10-16:50</td>
                                        <td className="agenda-td agenda-poster-blue">
                                            特殊研究計畫成果與申請計畫經驗分享<br />                                           
                                            <strong>16:00-16:25</strong> 主講人：國立臺灣大學 資訊工程學系 張原豪教授<br />
                                            <strong>16:25-16:50</strong> 主講人：國立陽明交通大學 電機工程學系 游家牧副教授<br />
                                            (蘇格拉底廳)
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="agenda-td">17:40-</td>
                                        <td className="agenda-td agenda-evening" colSpan="3">
                                            晚宴 / 最佳學生論文頒獎<br />
                                            （公館薪僑園水源會館）
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                        <h1 className="agenda-subtitle">2025/08/26 議程</h1>
                        <div className={`agenda-scroll-hint ${isMobile ? 'agenda-scroll-hint-mobile' : ''}`}>
                            ← 左右滑動查看完整表格 →
                        </div>
                        <div className="agenda-table-container">
                            <table className="agenda-table">
                                <thead>
                                    <tr>
                                        <th className="agenda-th">時間</th>
                                        <th className="agenda-th" colSpan="4">活動</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="agenda-td">08:30-09:00</td>
                                        <td className="agenda-td" colSpan="4">報到</td>
                                    </tr>
                                    <tr>
                                        <td className="agenda-td">09:00-09:30</td>
                                        <td className="agenda-td agenda-opening" rowSpan="2">
                                            WASN最佳論文發表<br />
                                            (拉斐爾廳)
                                        </td>
                                        <td className="agenda-td agenda-keynote" rowSpan="2">
                                            MC最佳論文發表<br />
                                            (達文西廳)
                                        </td>
                                        <td className="agenda-td" colSpan="2"></td>
                                    </tr>
                                    <tr>
                                        <td className="agenda-td">09:30-10:20</td>
                                        <td className="agenda-td agenda-poster-blue">
                                            Poster<br />
                                            論文研究成果發表 III<br />
                                            (亞歷山大廳)
                                        </td>
                                        <td className="agenda-td agenda-poster-green">
                                            Poster<br />
                                            國科會研究成果發表 III<br />
                                            (洛克廳)
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="agenda-td">10:20-10:30</td>
                                        <td className="agenda-td" colSpan="4">Break</td>
                                    </tr>
                                    <tr>
                                        <td className="agenda-td">10:30-11:20</td>
                                        <td className="agenda-td agenda-opening" colSpan="2">
                                            Keynote Speech III:<br />
                                            講者:國立臺灣大學電機工程學系<br />
                                            魏宏宇教授<br />
                                            主題: Smart Edge Computing and AIoT in the 6G Era<br />
                                            (拉斐爾廳)
                                        </td>
                                        <td className="agenda-td agenda-poster-blue">
                                            Poster<br />
                                            論文研究成果發表 IV<br />
                                            (亞歷山大廳)
                                        </td>
                                        <td className="agenda-td agenda-poster-green">
                                            Poster<br />
                                            國科會研究成果發表 IV<br />
                                            (洛克廳)
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="agenda-td">11:20-12:00</td>
                                        <td className="agenda-td agenda-evening" colSpan="4">
                                            閉幕 / 最佳研究成果頒獎<br />
                                            (拉斐爾廳)
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default Agenda;